import type { FunctionComponent } from 'react';
import SectionMessage from '@atlaskit/section-message';
import { defineMessages, useIntl } from 'react-intl';

const messages = defineMessages({
  authorizationTitle: {
    id: 'oauth.twg.authorizationBanner.title',
    defaultMessage: 'Verify this authorization request',
    description: 'Title for the TWG authorization request verification banner',
  },
  authorizationBody: {
    id: 'oauth.twg.authorizationBanner.body',
    defaultMessage:
      'Accept only if you created this request while authenticating the Teamwork Graph (twg) CLI on your own device.',
    description: 'Body for the TWG authorization request verification banner',
  },
});

const TwgConsentBanners: FunctionComponent = () => {
  const { formatMessage } = useIntl();

  return (
    <SectionMessage
      appearance="warning"
      title={formatMessage(messages.authorizationTitle)}
    >
      {formatMessage(messages.authorizationBody)}
    </SectionMessage>
  );
};

export default TwgConsentBanners;
